<template>
	<BlockLoader v-if="blocksReady" :blockContent="navigationBlocks" style="width: 100%" ref="blockLoader" />
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import { BlockLoader } from '@/tools/blockLoader';

export default {
	components: {
		BlockLoader,
	},
	computed: {
		...mapState(['dataSourceCFG', 'blocksReady']),
		...mapGetters(['getBlocksDevHash']),
		navigationBlocks() {
			const navigationJson = this.dataSourceCFG?.global?.navigationJson || {};
			return navigationJson
				? Object.keys(navigationJson).reduce((acc, key) => {
						if (key.startsWith('block')) {
							return [...acc, navigationJson[key]];
						}
						return acc;
				  }, [])
				: [];
		},
	},
	watch: {
		getBlocksDevHash() {
			this.$refs.blockLoader?.updateContent();
		},
	},
};
</script>
